import FSCss from "../../css/overview.module.css";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";

const FSTopBar = ({history, activeCat}) => {
  return (
    <div className={FSCss.w100}>
      <div className={FSCss.uploadLoansMainContainer}></div>

      <div className={`${FSCss.listPageheader} ${ activeCat === "socie" ? FSCss.socieHeaderFix : "" }`}>
        <div className={FSCss.headerLeftContainer}>
          <div className={FSCss.iconContainer}></div>
        </div>
        <div className={FSCss.headerRightContainer}>
          <Button
            btnColor={buttoncss.secondary}
            style={{ backgroundColor: "transparent" }}
            label="Link Registers"
            onClick={() => {
              history.push("/link-register");
              //   handleNew();
            }}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label="Finalise FS"
            //   onClick={handleFilter}
            onClick={() => {
              history.push("/finalize-fs");
              //   handleNew();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FSTopBar;